module.exports = __webpack_public_path__ + "static/media/Done_1.8626921f.PNG";